'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var wrap = {};

exports.__exports = wrap;
